import http from './http.service';

class RankingCriteriaService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/rankingCriteria";
    }

    getById(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/getById/${id}`);
    };

    getForEventId(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/getForEventId/${id}`);
    };

    create(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}/create`, model);
    };

    update(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.put(`${this.baseUrl}/update`, model);
    };

    addToEvent(eventId, ids) {
        if (!eventId) {
            throw new Error('EventId is required');
        }

        if (!ids) {
            throw new Error('RankingCriteriaIds is required');
        }

        return this.$http.post(`${this.baseUrl}/addToEvent`, { eventId: eventId, ids: ids });
    }

    getViewList(eventFormIds) {
        return this.$http.get(`${this.baseUrl}/viewList`, { params: { eventFormIds: eventFormIds } });
    }

    deleteFromEvent(eventId) {
        if (!eventId) {
            throw new Error('EventId is required');
        }

        return this.$http.delete(`${this.baseUrl}/deleteFromEvent`, { params: { eventId: eventId } });
    }
}

export default new RankingCriteriaService();
